export const siteConfig = {
  name: '17爆料网',
  shortName: '17',
  slogan: '一线线索 · 独家首发',
  description:
    '17爆料网聚焦未公开信息与内部消息，独家首发持续更新，汇集知情人士爆料与第一手料整理，用时间线帮你掌握事件脉络。',
  email: 'tips@17baoliao.cn',
  updatedAt: '2026-09-12',
  nav: [
    { label: '首页', to: '/' },
    { label: '独家追踪', to: '/#tracking' },
    { label: '分类', to: '/#categories' },
    { label: '常见问题', to: '/faq' },
    { label: '关于我们', to: '/about' },
    { label: '我要爆料', to: '/contact' },
  ],
};

export const tickerItems = [
  '某热门剧集临开机更换主演，三条时间线交叉还原争议焦点',
  '折叠屏新品发布前夜：供应链细节透露了哪些信号',
  '新消费品牌关店潮背后：门店数据与租约成本的这本账',
  '小众 AI 团队被曝完成新一轮融资，产品数据拆解',
  '老旧小区加装电梯推进遇阻：三个小区的实践样本',
  '露营热退潮后的营地生存报告：从排队到空置',
];